module.exports = __webpack_public_path__ + "static/media/loseTableAllTricks_1.1c41dc60.png";